import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-profile',
  templateUrl: './ui-profile.component.html',
  styleUrls: ['./ui-profile.component.scss'],
})
export class UiProfileComponent {
  activeTab: string = 'withRating'; // Default active tab
  showWithRating(event: Event) {
    event.preventDefault();
    this.activeTab = 'withRating';
  }
  showNew(event: Event) {
    event.preventDefault();
    this.activeTab = 'new';
  }
}
